const scrollToOverlayListItemObserver = (value) => {
    return new MutationObserver((mutationsList) => {
        const optionsList =
            mutationsList?.[0]?.addedNodes[0]?.childNodes[0]?.childNodes[0]?.childNodes[0];
        if (optionsList) {
            const optionsListItems = Array.from(optionsList?.childNodes);
            const selectedOption = optionsListItems.find(
                (listItem) => listItem.getAttribute('data-keyvalue') === value,
            );
            selectedOption?.scrollIntoView();
        }
    });
};

export default scrollToOverlayListItemObserver;
